import { API_BASE_URL } from '@/config';
import axios from 'axios';

export class RefundFilesApi {
  static getAdminRefundFiles = ({
    organizationId,
    facilityId,
    fileStatus,
    page,
    limit,
  }) => {
    return axios.post(`${API_BASE_URL}/adminGetFilesList`, {
      organizationId,
      facilityId,
      fileStatus,
      page,
      limit,
    });
  };
}
